import React, { Component } from 'react';
import SuperhighlightAddOn from './Components/SuperhighlightAddOn';
import LayoutOneAddOn from './Components/LayoutOneAddOn';
import LayoutTwoAddOn from './Components/LayoutTwoAddOn';
import LayoutThreeAddOn from './Components/LayoutThreeAddOn';
import LayoutFourAddOn from './Components/LayoutFourAddOn';
import './_styles.scss';

class LandingComercialAddOn extends Component {
	constructor(props) {
		super(props);
	}

	getLayout = (groups = []) => {
		const itemsNumber = groups.length;
		switch (itemsNumber) {
			case 1:
			    return <LayoutOneAddOn groups={groups} />
			case 2:
			    return <LayoutTwoAddOn groups={groups} />
			case 3:
			    return <LayoutThreeAddOn groups={groups} />
			case 4:
				return <LayoutFourAddOn groups={groups} />
			default:
				return <LayoutFourAddOn groups={groups} />
		}
	};

	render() {
		const { superhighlight = {}, posters = {} } = this.props;

		const { highlight = [] } = superhighlight || {};
		const { groups = [] } = posters || {};
		
		const showSuperhighlight = highlight && highlight.length > 0;
		const showPosters = groups && groups.length > 0;

		return (
			<div className="landing-comercial-add-on">
				{ showSuperhighlight && <SuperhighlightAddOn image={highlight[0].image_highlight} /> }
				{ showPosters && this.getLayout(groups) }
			</div>
		);
	}
}

export default LandingComercialAddOn;



// WEBPACK FOOTER //
// ./src/payments/DetailSelector/LandingComercialAddOn/index.jsx